import React from "react";
import PropTypes from "prop-types";


export default function GuideLine({
  guide,
  onPointerDown = null,
  onDoubleClick = null,
}) {
  const style =
    guide.orientation === "vertical"
      ? {
          left: `${guide.screenPosition}px`,
        }
      : {
          top: `${guide.screenPosition}px`,
        };

  return (
    <div
      className={[
        "studio-guide",
        `studio-guide--${guide.orientation}`,
        guide.locked
          ? "studio-guide--locked"
          : "studio-guide--movable",
      ].join(" ")}
      data-guide-id={guide.id}
      data-guide-orientation={guide.orientation}
      data-guide-position={guide.position}
      data-guide-locked={guide.locked ? "true" : "false"}
      style={style}
      onPointerDown={
        guide.locked
          ? undefined
          : onPointerDown
      }
      onDoubleClick={onDoubleClick}
      role="presentation"
    />
  );
}


GuideLine.propTypes = {
  guide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    orientation: PropTypes.oneOf([
      "horizontal",
      "vertical",
    ]).isRequired,
    position: PropTypes.number.isRequired,
    screenPosition: PropTypes.number.isRequired,
    locked: PropTypes.bool.isRequired,
  }).isRequired,
  onPointerDown: PropTypes.func,
  onDoubleClick: PropTypes.func,
};
